import Button from '@ramsey-design-system/button';
import { VerificationStatus } from '../../enums';

interface SubmitButtonProps {
  status: VerificationStatus;
}

function getSubmitButtonText(status: VerificationStatus) {
  if (
    VerificationStatus.verifyingCode === status ||
    VerificationStatus.submittingReferral === status
  ) {
    return 'Verifying Code . . .';
  } else {
    return 'See My Pro';
  }
}

export function SubmitButton({ status }: Readonly<SubmitButtonProps>) {
  const submitButtonText = getSubmitButtonText(status);

  return (
    <Button
      type="submit"
      className="!w-full"
      fullWidthOnMobile={true}
      size="large"
      id="see_pros"
      data-testid="tax_see_pros_submit"
      loading={submitButtonText !== 'See My Pro'}
      // Submitting the old code while a resend is in flight supersedes the code the user is about
      // to receive, which is what leaves them unable to verify even with a fresh code.
      disabled={status === VerificationStatus.resendingCode}
    >
      {submitButtonText}
    </Button>
  );
}
